import { Platform } from "@ionic/angular";
import { BehaviorSubject } from "rxjs";
// import { Motion } from "@capacitor/motion";
import { inject, Injectable } from "@angular/core";
import { Capacitor } from "@capacitor/core";
import { Geolocation } from "@capacitor/geolocation";
import { TranslateService } from "@ngx-translate/core";
import { ToastService } from "../toast-service/toast.service";
// import { Geolocation, Position } from "@capacitor/geolocation";

@Injectable({ providedIn: "root" })
export class LocationService {
  platform = inject(Platform);
  toast = inject(ToastService);
  private translate = inject(TranslateService);

  private location = new BehaviorSubject<{
    lat: number;
    lng: number;
  } | null>(null);
  public location$ = this.location.asObservable();

  // smoothHeading: number = 0;
  // watchLocationId: string | null = null;
  // public currentLocation: { lat: number; lng: number } | null = null;

  // public onLocationChange = new BehaviorSubject<{
  //   lat: number;
  //   lng: number;
  //   heading: number;
  // } | null>(null);

  constructor() {
    // this.startTracking();
    // this.startOrientationTracking();
  }

  async GetCurrentLocation(force: boolean = false): Promise<void> {
    const isDevice = Capacitor.isNativePlatform();

    const options: PositionOptions = {
      maximumAge: 0, // always request fresh location
      timeout: 10000,
      enableHighAccuracy: true,
    };

    try {
      // -------------------------------
      // 1️⃣ Native platforms (iOS / Android)
      // -------------------------------
      if (isDevice) {
        const permissionStatus = await Geolocation.checkPermissions();

        if (permissionStatus.location !== "granted") {
          const requestStatus = await Geolocation.requestPermissions();

          if (requestStatus.location !== "granted") {
            this.toast.toastWarning(
              this.translate.instant("SERVICES_LOCATION_PERMISSION_DENIED"),
            );
            return;
          }
        }

        const { coords } = await Geolocation.getCurrentPosition(options);
        this.location.next({ lat: coords.latitude, lng: coords.longitude });
      } else {
        // -------------------------------
        // 2️⃣ Web (Browser)
        // -------------------------------
        if (!navigator.geolocation) {
          this.toast.toastWarning(
            this.translate.instant("SERVICES_GEOLOCATION_SUPPORTED_BY_BROWSER"),
          );
          return;
        }

        navigator.geolocation.getCurrentPosition(
          ({ coords }) => {
            this.location.next({ lat: coords.latitude, lng: coords.longitude });
          },
          (err) => {
            console.error("Geolocation error:", err);
            this.location.next(null);
          },
          options,
        );
      }
    } catch (error) {
      this.toast.toastWarning(
        this.translate.instant("SERVICES_FAILED_TO_GET_LOCATION"),
      );
      return;
    }
  }

  // ** Start watching the user's location
  // async startTracking() {
  //   this.watchLocationId = await Geolocation.watchPosition(
  //     { enableHighAccuracy: true },
  //     (position: Position | null) => {
  //       if (position) {
  //         const currentCoordinates = {
  //           lat: position.coords.latitude,
  //           lng: position.coords.longitude,
  //           heading: this.getHeading(position),
  //         };
  //         if (this.onLocationChange) {
  //           this.onLocationChange.next(currentCoordinates);
  //         }
  //       }
  //     },
  //   );
  // }

  // ** Determine heading based on motion or GPS
  // private getHeading(position: Position): number {
  //   const speed = position.coords.speed || 0;
  //   // Use GPS heading if speed > 0.5 m/s, else fallback to smoothed heading
  //   return speed > 0.5 && position.coords.heading !== null
  //     ? position.coords.heading!
  //     : this.smoothHeading;
  // }

  // ** Track device orientation
  // startOrientationTracking() {
  //   Motion.addListener("orientation", (event) => {
  //     if (event?.alpha !== undefined) {
  //       const heading = event.alpha;
  //       const currentLocation = this.onLocationChange.getValue();
  //       if (currentLocation) {
  //         currentLocation.heading = heading;
  //         this.onLocationChange.next(currentLocation);
  //       }
  //     }
  //   });
  // }

  // ** Stop watching the user's location
  // stopTracking() {
  //   if (this.watchLocationId) {
  //     Geolocation.clearWatch({ id: this.watchLocationId });
  //     this.watchLocationId = null;
  //   }
  // }
}
